import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const STORAGE_KEY = "tgl_admin";

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach the logged-in admin's id to every request so the backend's
// require_admin dependency can authenticate. Skipped on /admin/login itself.
api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const admin = JSON.parse(raw);
      if (admin?.id && !config.url?.includes("/admin/login")) {
        config.headers["X-Admin-Id"] = admin.id;
      }
    }
  } catch {
    /* localStorage unavailable — request will fail at the server with 401 */
  }
  return config;
});

// If we get back 401/403 anywhere, surface a clean error message and clear
// stale auth so the user is bounced back to /login on next render.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      // Only auto-logout when the failure was an auth failure on a gated route.
      const url = error?.config?.url || "";
      // Skip auto-logout for these routes: login itself (obvious), and the
      // admin change-password endpoint where a 401 means "wrong current
      // password" — the admin is still validly signed in.
      const skip =
        url.includes("/admin/login") ||
        url.includes("/users/login") ||
        url.includes("/admin/change-password");
      if (!skip) {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch {
          /* ignore */
        }
      }
    }
    const detail = error?.response?.data?.detail || error?.message || "Request failed";
    error.userMessage = typeof detail === "string" ? detail : JSON.stringify(detail);
    return Promise.reject(error);
  }
);
